import { observer } from 'mobx-react-lite'
import { TextToSpeech, type TextToSpeechWidgetStore } from 'widgets/TextToSpeech'
import { TextToSpeechModalActions } from 'widgets/TextToSpeech/ui/TextToSpeechModalActions/TextToSpeechModalActions'
import styles from './styles.module.scss'

export const VoicemailDropTextToSpeechModalContent = observer(
  ({ store, onClose }: { store: TextToSpeechWidgetStore; onClose: () => void }) => {
    return (
      <>
        <div className={styles.content}>
          <TextToSpeech store={store} variant={'modal'} />
        </div>
        <div className={styles.footer}>
          <TextToSpeechModalActions store={store} onClose={onClose} />
        </div>
      </>
    )
  }
)
